import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

interface IProps {
  label?: string;
  isOptional?: boolean;
  required?: boolean;
  children: React.ReactNode;
  formItemLabelStyle?: CSSProperties;
}

const FormItem: React.FC<IProps> = ({
  formItemLabelStyle,
  label,
  required,
  isOptional,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.formItem}>
      <label
        style={formItemLabelStyle}
        className={!formItemLabelStyle ? styles.formItemLabel : ""}
      >
        {required && <span className={styles.star}>*</span>}
        {label} {isOptional && <span>({t("optional")})</span>}
      </label>
      {children}
    </div>
  );
};

export default FormItem;
